var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDirectionsCarCircle40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0V0C31.0457 0 40 8.9543 40 20V20C40 31.0457 31.0457 40 20 40V40C8.9543 40 0 31.0457 0 20V20Z",
    fill: "#0033AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.92 14.01C26.72 13.42 26.16 13 25.5 13H14.5C13.84 13 13.29 13.42 13.08 14.01L11 20V28C11 28.55 11.45 29 12 29H13C13.55 29 14 28.55 14 28V27H26V28C26 28.55 26.45 29 27 29H28C28.55 29 29 28.55 29 28V20L26.92 14.01ZM14.85 15H25.14L26.22 18.11H13.77L14.85 15ZM27 25H13V20H27V25Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 24C16.3284 24 17 23.3284 17 22.5C17 21.6716 16.3284 21 15.5 21C14.6716 21 14 21.6716 14 22.5C14 23.3284 14.6716 24 15.5 24Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 24C25.3284 24 26 23.3284 26 22.5C26 21.6716 25.3284 21 24.5 21C23.6716 21 23 21.6716 23 22.5C23 23.3284 23.6716 24 24.5 24Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDirectionsCarCircle40Px);
export default __webpack_public_path__ + "static/media/ic_directions_car_circle-40px.788d3cd93ccc25bdf6c87097efd74d6d.svg";
export { ForwardRef as ReactComponent };